import { useAsyncFn } from '@clara/hooks'
import { http } from '@/lib'

import { TabsCountResponse } from '../types/reimbursement'

export async function request() {
  return http.get<TabsCountResponse>('/tabs-count').then((res) => res.data)
}

export function useGetTabsCount() {
  return useAsyncFn(async () => {
    const res = await request()
    return res
  }, [])
}
